<template>
  <GenericLayout :title="$t('PRIVACY_POLICY')" class="fill-height">
    <PrivacyEs v-if="$i18n.locale === 'es'" />
    <PrivacyEn v-else />
  </GenericLayout>
</template>

<style scoped>
>>> .container {
  max-width: 800px;
  margin: 0 auto;
}

>>> h1 {
  text-align: center;
  margin: 16px 0 32px;
}
</style>

<script>
import GenericLayout from '@/layouts/GenericLayout.vue';

import PrivacyEs from '@/views/legal/PrivacyEs.vue';
import PrivacyEn from '@/views/legal/PrivacyEn.vue';

export default {
  name: 'Privacy',
  components: {
    GenericLayout,
    PrivacyEs,
    PrivacyEn,
  },
};
</script>
